( function ($) {

    $('[data-toggle="popup"]').popover({
        trigger: 'click',
        placement: 'top',
        html: true
    });

    $('body').on('click', function (event) {
        $('[data-toggle="popup"]').each( function () {
            if (! $(this).is(event.target) && $(this).has(event.target).length === 0 && $('.popover').has(event.target).length === 0) {
                $(this).popover('hide');
            }
        });
    });

}(jQuery));

(function ($) {

    const $accordionHeader = $('#add-child-form');
    const $closeButton = $('#form-child-cancel');
    const $childForm = $('#child-form');
    const $addChildButton = $('#add-child-btn');
    const $iconPlus = $('#icon-plus');
    const $iconCross = $('#icon-cross');

    let $ariaState;
    $ariaState = $accordionHeader.find('button[aria-expanded]').attr('aria-expanded');
    
    $addChildButton.on('click', () => {
        $iconPlus.toggleClass('hidden', $ariaState);
        $iconCross.toggleClass('hidden', $ariaState);
    });

    $closeButton.on('click', () => {
        $accordionHeader.find('button[aria-expanded]').attr('aria-expanded', !$ariaState);
        $childForm.addClass('hidden');

        $('#form-add').find('input').not('input[name="action"],input[name="_token"]').val('').removeClass('incorrect');
        $('.text-input-error').each(function (event) {
            $(this).attr("style", "display:none");
        });
    });

}(jQuery));
